module.exports = __webpack_public_path__ + "static/media/past.79b355e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/past.jpg
// module id = 970
// module chunks = 0